import { NumberedGrid } from '@mc/educator-design-system'
import { useTranslation } from '@mc/i18n'
import type { SubjectModule } from '../../../../types/subjects'
import { SectionContainer } from '../../SectionContainer'

interface SubjectModulesSectionProps {
  sectionTitle: string
  modules: SubjectModule[]
  onModuleClick?: (module: SubjectModule) => void
}

export const SubjectModulesSection = ({
  sectionTitle,
  modules,
  onModuleClick,
}: SubjectModulesSectionProps) => {
  const { t } = useTranslation('@mc/educator')
  return (
    <section
      data-section='subject-modules'
      className='w-full bg-black py-8 md:py-4'
    >
      <SectionContainer>
        <NumberedGrid
          title={sectionTitle}
          items={modules.map((m) => m.title)}
          disclaimer={t('subjectLandingPage.subjectModules.disclaimer')}
          onItemClick={
            onModuleClick ? (index) => onModuleClick(modules[index]) : undefined
          }
        />
      </SectionContainer>
    </section>
  )
}
